import React, { useEffect, useState } from "react"
import CourseCard from "../Reusable/CourseCard"
import Textarea from "../Reusable/Input/textarea"
import Modal from "../Reusable/Modal"
import { AllCoursesStyles, ModalStyle } from "./style"
import RatingReview from "../Reusable/RatingReview"
import Button from "../Reusable/Button"
import { toast } from "react-toastify"
import {
  getRatingByCourseAndUser,
  submitEditedCourseReview,
  submitReview,
} from "../../services/course"
import Image from "../image"

const AllCourses = ({
  courses,
  hidePrice,
  showReview,
  userID,
  updateCourses,
}) => {
  const [showModal, setShowModal] = useState(false)
  const [showModalSuccess, setShowModalSuccess] = useState(false)
  const [courseModal, setCourseModal] = useState()
  const [dataModal, setDataModal] = useState()
  const [review, setReview] = useState()
  const [comment, setComment] = useState()
  const [reviews, setReviews] = useState([])

  useEffect(() => {
    const getCourseReviews = async () => {
      const newReviews = []
      for (let i = 0; i < courses.length; i++) {
        const resp = await getRatingByCourseAndUser(courses[i].id, userID)
        if (resp.data?.results[0]) {
          newReviews.push(resp.data?.results[0])
        }
      }
      return newReviews
    }

    if (!reviews || reviews?.length === 0) {
      getCourseReviews().then(newReviews => {
        setReviews(newReviews)
      })
    }
  }, [courses])

  const getCourseModal = (course, dataRewiew) => {
    setCourseModal(course)
    if (dataRewiew) {
      setReview(dataRewiew.rate)
      setComment(dataRewiew.comment)
      setDataModal(dataRewiew)
    }
    setShowModal(true)
  }

  const closeModal = course => {
    setShowModal(false)
    setReview(0)
    setComment("")
  }

  const failed = () => {
    toast.error("Terjadi kesalahan")
  }

  const handleSubmit = async (courseID, review, comment) => {
    if (dataModal) {
      const resp = await submitEditedCourseReview(dataModal.id, {
        rate: review,
        comment: comment,
      })
      if (resp?.status === 200) {
        setReview(0)
        setComment("")
        setCourseModal(null)
        setShowModal(false)
        setShowModalSuccess(true)
        getRatingByCourseAndUser(courseID, userID).then(response => {
          if (response.data?.results[0] !== undefined) {
            setReviews(prev => {
              const index = prev.findIndex(p => p.id === dataModal.id)
              const newReview = prev[index]
              newReview.rate = review
              newReview.comment = comment
              prev[index] = newReview
              return prev
            })
          }
        })
        updateCourses(courseID)
        setDataModal(null)
      } else {
        failed()
      }
    } else {
      const resp = await submitReview({
        course: courseID,
        rate: review,
        comment: comment,
      })
      if (resp?.status === 201) {
        setShowModal(false)
        setShowModalSuccess(true)
        setReview(0)
        setComment("")
        setCourseModal(null)
        getRatingByCourseAndUser(courseID, userID).then(response => {
          if (response.data?.results[0] !== undefined) {
            setReviews(prev => [...prev, response.data?.results[0]])
          }
        })
        updateCourses(courseID)
      } else {
        failed()
      }
    }
  }

  const handleTextArea = event => {
    setComment(event.target.value)
  }

  const bodyModal = (
    <ModalStyle>
      {reviews.find(e => e.course === courseModal?.id) ? (
        <div className="title">Edit Ulasan</div>
      ) : (
        <div className="title">Beri Ulasan</div>
      )}
      <div className="kursus-detail">
        <img src={courseModal?.thumbnail} className="image" />
        <div
          style={{ display: "flex", flexDirection: "column" }}
          className="title-utama"
        >
          <div>{courseModal?.title}</div>
          <div className="nama-tutor">{courseModal?.tutor?.display_name}</div>
        </div>
      </div>
      <div className="rating">
        <RatingReview
          funcOnClick={value => {
            setReview(value)
          }}
          initRating={review}
        />
      </div>
      <div className="pendapat">
        <Textarea
          id="text"
          label="Berikan pendapat anda"
          placeholder="Tuliskan gambaran anda tentang kursus"
          className="textArea"
          onChange={event => handleTextArea(event)}
          value={comment}
          style={{ maxHeight: "220px" }}
        />
      </div>
      {review ? (
        <Button
          onClick={() => handleSubmit(courseModal.id, review, comment)}
          className="submit"
        >
          submit
        </Button>
      ) : (
        <Button
          disabled
          style={{
            background: "grey",
            border: "grey",
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          }}
          className="submit"
        >
          submit
        </Button>
      )}
    </ModalStyle>
  )

  const bodySuccess = (
    <div style={{ margin: "30px 45px" }}>
      <div>
        <Image
          style={{
            margin: "auto",
            width: "70px",
          }}
          imgName="successReview.png"
          alt="successReview"
        />
      </div>
      <div style={{ color: "#F9C115", paddingTop: "20px" }}>
        Terima kasih atas ulasan kamu
      </div>
    </div>
  )

  return (
    <div>
      <AllCoursesStyles>
        {reviews?.length !== 0 && (
          <div className="kursus-list">
            {courses.map((course, index) => {
              return (
                <div key={course.id}>
                  <CourseCard
                    course={course}
                    key={index}
                    hidePrice={hidePrice}
                    showEdit={
                      reviews?.length > 0
                        ? reviews.find(e => e.course === course.id)
                        : false
                    }
                    showReview={showReview}
                    showModal={() =>
                      getCourseModal(
                        course,
                        reviews.find(e => e.course === course.id)
                      )
                    }
                  />
                </div>
              )
            })}
          </div>
        )}
        {courses?.length !== 0 && !reviews?.length && (
          <div className="kursus-list">
            {courses.map((course, index) => {
              return (
                <div key={course.id}>
                  <CourseCard
                    course={course}
                    key={index}
                    hidePrice={hidePrice}
                    showEdit={false}
                    showReview={showReview}
                    showModal={() => getCourseModal(course)}
                  />
                </div>
              )
            })}
          </div>
        )}
        {!courses?.length && (
          <div
            className="layout"
            style={{ color: "gray", paddingTop: "10px", textAlign: "center" }}
          >
            No result to show
          </div>
        )}

        <Modal
          visible={showModal}
          body={bodyModal}
          close={() => closeModal()}
          closeBackground={() => setShowModal(false)}
        />
        <Modal
          visible={showModalSuccess}
          body={bodySuccess}
          closeBackground={() => setShowModalSuccess(false)}
        />
      </AllCoursesStyles>
    </div>
  )
}

export default AllCourses
